import { parse, stringify } from 'flatted';

const deepCopy = (value) => Object.freeze(parse(stringify(value)));

export { deepCopy };
